// 前台数据
import axios from '@/http/index'

// 获取所有的APP和价格信息
export const get_vip_config = (params) => {
    return axios({
        method: 'GET',
        url: '/vip/app_config',
		params
    })
}

// 获取单个的APP和价格信息
export const getOneVipConfig = (params) => {
    return axios({
        method: 'GET',
        url: '/vip/app_config_one',
		params
    })
}

// 个人-查询未过期次卡剩余总次数
export const getVipList = (params) => {
    return axios({
        method: 'GET',
        url: '/vip/app_available_use_count',
		params
    })
}

// 单位-查询未过期次卡剩余总次数
export const getGidVipList = (data) => {
    return axios({
        method: 'POST',
        url: '/vip/get_gid_limit_status',
		data
    })
}

// 个人-查询当前次卡剩余总次数使用记录
export const getVipRecordList = (params) => {
    return axios({
        method: 'GET',
        url: '/vip/use_record_list',
		params
    })
}

// 查询单个产品appid次卡的个人+单位的消耗记录
export const getVipUserRecordItem = (params) => {
    return axios({
        method: 'GET',
        url: '/vip/use_record_items',
		params
    })
}

// 获取订单号-单品
export const vip_create_order = (params) => {
    return axios({
        method: 'GET',
        url: '/pay/create_order',
		params
    })
}

// 获取微信订单
export const getWXcode = (params) => {
    return axios({
        method: 'GET',
        url: '/pay/create_order_wx',
		params
    })
}

// 获取支付宝订单
export const getZFBcode = (params) => {
    return axios({
        method: 'GET',
        url: '/pay/create_order_ali',
		params
    })
}

// 获取订单状态
export const getOrderStatus = (params) => {
    return axios({
        method: 'GET',
        url: '/pay/order_status',
		params
    })
}


// 获取订单号-套餐
export const vip_create_order_all = (params) => {
    return axios({
        method: 'GET',
        url: '/pay_plan/create_order',
		params
    })
}

// 获取微信订单-套餐
export const getWXcodeAll = (params) => {
    return axios({
        method: 'GET',
        url: '/pay_plan/create_order_wx',
		params
    })
}

// 获取支付宝订单-套餐
export const getZFBcodeAll = (params) => {
    return axios({
        method: 'GET',
        url: '/pay_plan/create_order_ali',
		params
    })
}

// 获取订单状态-套餐
export const getOrderStatusAll = (params) => {
    return axios({
        method: 'GET',
        url: '/pay_plan/order_status',
		params
    })
}

// 用户提交反馈
export const submitFeedback = (data) => {
    return axios({
        method: 'POST',
        url: '/feedback/user_submit',
		data
    })
}

// 判断提交信息是否补全 
export const sendFirMsg = (data) => {
    return axios({
        method: 'POST',
        url: '/medical/check',
		data
    })
}

// 分页查询用户订单列表
export const getPayList = (data) => {
    return axios({
        method: 'POST',
        url: '/order/page',
		data
    })
}

// 获取订单号获取到期时间
export const getOrderDueDate = (params) => {
    return axios({
        method: 'GET',
        url: '/order/order_due_date',
		params
    })
}

// 发票
// 保存发票抬头信息
export const saveInvoceInfo = (data) => {
    return axios({
        method: 'POST',
        url: '/invoice/save_invoice_info',
		data,
    })
}

// 获取发票抬头信息
export const getInvoceInfo = (params) => {
    return axios({
        method: 'GET',
        url: '/invoice/get_invoice_info',
		params,
    })
}

// 申请开票
export const applyInvoice = (data) => {
    return axios({
        method: 'POST',
        url: '/invoice/apply_invoice',
		data,
    })
}


// 活动奖励/佣金
// 获取佣金金额
export const getCommisSum = (params) => {
    return axios({
        method: 'GET',
        url: '/commission/summary',
		params,
    })
}

// 获取佣金-订单-列表
export const getOrderList = (params) => {
    return axios({
        method: 'GET',
        url: '/commission/eligible_list',
		params,
    })
}

// 提现申请
export const applyWithdraw = (data) => {
    return axios({
        method: 'POST',
        url: '/commission/withdraw',
		data,
    })
}

// 获取收款账户信息
export const getReceivableAccount = (params) => {
    return axios({
        method: 'GET',
        url: '/commission/withdraw_account',
		params,
    })
}

// 保存收款账户信息
export const saveReceivableAccount = (params) => {
    return axios({
        method: 'GET',
        url: '/commission/save_withdraw_account',
		params,
    })
}

// 获取提现申请详情
export const getWithdrawDetail = (params) => {
    return axios({
        method: 'GET',
        url: '/commission/detail',
		params,
    })
}

// 邀请码数量统计
export const vipCountl = (params) => {
    return axios({
        method: 'GET',
        url: '/vip/count',
		params,
    })
}

// 兑换VIP权益
export const redeemExchange = (data) => {
    return axios({
        method: 'POST',
        url: '/redeem/exchange',
		data
    })
}

// 获取兑换记录
export const getRedeemRecords = (params) => {
    return axios({
        method: 'GET',
        url: '/redeem/record_list',
		params
    })
}